import { gql } from "generated-graphql";

export const INTERNAL_TAGS_BY_NAME_QUERY = gql(`
  query InternalTagsByName($search: String!, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
    internalTagsByName(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
      items {
        name
        facilityCount
      }
      count
    }
  }
`);
